<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Projeto - Link Evidência</h2>
    <h3>Admin</h3>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="new-project">
      <a class="btn btn-primary" [routerLink]="['/pre-projeto/admin/link-evidencia/adicionar']">Novo</a>
    </div>
  </div>
</div>

<div class="system-table p-h-lg">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="width5">ID</th>
          <th>Nome</th>
          <th class="text-center width5">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of list">
          <tr>
            <td class="title">{{ item?.id }}</td>
            <td><span class="title-span">{{ item?.name }}</span></td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="item?.id">
                  <img src="assets/images/svgs/editar1.svg" tooltip="Visualizar" placement="bottom">
                </a>
                <span class="icon-table" (click)="confirmExcluir(item?.id)">
                  <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                </span>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!list?.length" class="border-b-radius">
          <td colspan="3" class="text-center">Nenhum Cadastro Encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>